module.exports = __webpack_public_path__ + "img/smartcard.c9cc8979.png";